/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
/* eslint-disable radix */

import {
    debounce,
    getScreenSize,
    appendToUrl,
    scrollLock
} from './util';
import {
    getCountryCode,
    getScreenResolution,
    updateUrl,
    isFirstMobileTile,
    initSwiper,
    adjustMapView,
} from './searchHelpers';
import location from './components/location';
import addProduct from './components/addProduct';
import coordinates from '../../../config/coordinates.json';

import {
    KEYBOARD_KEYS,
    handleEscapeKey,
    trapModalFocus,
    removeModalFocus,
    saveFocus,
    restoreFocus,
} from './a11yHelper';

import GtmParametersBuilder from './gtm/gtmParametersBuilder';

require('./components/loader');

const MOBILE_MAX_WIDTH = '(max-width: 900px)';
const DEFAULT_ZOOM_LEVEL = 10;

// Check if is mouse or keyboard interaction

let isKeyboardNavigation = false;

document.addEventListener('keydown', (e) => {
    if (e.key === KEYBOARD_KEYS.TAB || e.key === KEYBOARD_KEYS.ARROW_UP || e.key === KEYBOARD_KEYS.ARROW_UP) {
        isKeyboardNavigation = true;
    }
});

document.addEventListener('mousedown', () => {
    isKeyboardNavigation = false;
});

document.addEventListener('touchstart', () => {
    isKeyboardNavigation = false;
});


const Finder = (() => {
    let mapbox;
    let clusters;
    let selectedClubSwiper;
    let swiperIntersectionObserver;
    let realMobileCLubDetailHeight;

    /**
     * Gets a list of selected filter ids
     * @returns {Array} - List of selected filter ids
     */
    const getSelectedFilters = () => $('.js-club-finder-filter:checked').map((i, filter) => $(filter).attr('name')).get();

    /**
     * Adds parameters to the given URL
     * @param {string} url - URL
     * @param {string} pid - Store id to fetch a selected store data
     * @param {boolean} isMore - True if the given URL is used to fetch more store tiles for the grid, False otherwise
     * @param {boolean} isSuggestions - True if the given URL is used to fetch store tiles for the search suggestions, False otherwise
     * @returns {string} - Enriched URL
     */
    const enrichUrl = (url, pid, isMore, isSuggestions) => {
        const $grid = $('.js-club-finder-grid');
        const $searchInput = $('.js-club-finder-search-input');
        const q = $searchInput.val();
        const filters = getSelectedFilters();
        const lat = $grid.attr('data-latitude');
        const long = $grid.attr('data-longitude');
        const urlParameters = {};

        if (q) {
            urlParameters.q = q;
        }

        if (filters && filters.length > 0) {
            urlParameters.filters = filters;
        }

        if (lat) {
            urlParameters.lat = lat;
        }

        if (long) {
            urlParameters.long = long;
        }

        if (pid) {
            urlParameters.pid = pid;
        }

        if (isMore) {
            urlParameters.s = $grid.attr('data-page-start');
            urlParameters.sz = $grid.attr('data-page-size');
            urlParameters.isLoadMore = isMore;
        }

        if (isSuggestions) {
            urlParameters.isFinderSuggestions = isSuggestions;
        }

        return appendToUrl(url, urlParameters);
    };

    /**
     * Toggles search submit button (active/inactive)
     * @param {boolean} isActive - True if the submit button should be enabled, False otherwise
     */
    const toggleSearchSubmitButton = (isActive) => {
        const $button = $('.js-club-finder-search-submit');

        setTimeout(() => {
            $button.toggleClass('club-finder-search-submit--active', isActive);
            $button.prop('disabled', !isActive);
            $button.attr('aria-disabled', !isActive);
        }, 300);
    };

    /**
     * Builds sentinel HTML element for the current store grid to be used to initialize Intersection Observer API
     */
    const buildSentinel = () => {
        const $grid = $('.js-club-finder-grid');
        const $backToTop = $('.js-back-to-top');
        const moreUrl = $grid.attr('data-more-url');
        const url = enrichUrl(moreUrl, null, true, false);
        const sentinel = document.createElement('li');
        const $loader = $('<li />');

        sentinel.classList.add('sentinel', 'js-club-finder-grid-sentinel');
        $loader.addClass('loadcontainer js-loader');

        $backToTop.before($loader);
        $backToTop.before(sentinel);

        const targetObserver = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio > 0) {
                targetObserver.disconnect();
                $loader.loader().start();

                $.ajax({
                    url,
                    type: 'GET',
                    dataType: 'json',
                    success: (data) => {
                        $loader.loader().stop();
                        $loader.remove();

                        $grid.attr('data-page-start', data.pageStart);
                        $grid.attr('data-page-size', data.pageSize);
                        $grid.attr('data-page-complete', data.isComplete);
                        $grid.find('.js-club-finder-grid-sentinel').each((i, currentSentinel) => {
                            $(currentSentinel).remove();
                        });

                        $backToTop.before(data.storeTilesHtml);
                        updateUrl({
                            s: data.pageStart - data.pageSize,
                            sz: data.pageSize,
                        });

                        const $storeTiles = $grid.find('.js-store-tile');
                        $storeTiles.each((i, tile) => {
                            const $tile = $(tile);
                            const pid = $tile.attr('data-pid');

                            if (data.storeTilesHtml.indexOf(pid) < 0) {
                                return;
                            }

                            swiperIntersectionObserver.observe(tile);
                        });

                        if (data.isComplete) {
                            const $backToTopLink = $backToTop.find('a');
                            $backToTopLink.addClass('active');
                        } else {
                            buildSentinel();
                        }
                    },
                });
            }
        }, {
            threshold: 0.1,
        });

        targetObserver.observe(sentinel);
    };

    /**
     * Builds current location dot on the map
     * @param {number} lat - Latitude
     * @param {number} long - Longitude
     * @param {boolean} isZoomIn - True if we need to zoom in to the built location dot, False otherwise
     */
    const buildLocation = (lat, long, isZoomIn) => {
        const $locationPoint = $('.my-location');

        if ($locationPoint.length < 1) {
            const locationPoint = document.createElement('div');
            locationPoint.classList.add('bf-marker', 'active', 'my-location');

            new mapboxgl.Marker(locationPoint) // eslint-disable-line no-undef
                .setLngLat([long, lat])
                .addTo(mapbox);
        }

        if (isZoomIn) {
            mapbox.flyTo({
                center: [long, lat],
                offset: [100, 0],
                zoom: 10,
                speed: 0.6,
            });
        }
    };

    /**
     * Builds map clusters
     * @param {number} clusterRadius - Cluster radius in px
     */
    const buildClusters = (clusterRadius) => {
        if (!clusters || typeof mapbox === 'undefined') {
            return;
        }

        mapbox.addSource('clusters', {
            type: 'geojson',
            data: clusters,
            cluster: true,
            clusterMaxZoom: 12,
            clusterRadius,
        });

        mapbox.addLayer({
            id: 'circles',
            type: 'circle',
            source: 'clusters',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': [
                    'step',
                    ['get', 'point_count'],
                    '#ffffff',
                    100,
                    '#ffffff',
                ],
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    16,
                    100,
                    30,
                ],
                'circle-stroke-color': 'rgba(254, 112, 0, 0.2)',
                'circle-stroke-width': 1,
            },
        });

        mapbox.addLayer({
            id: 'labels',
            type: 'symbol',
            source: 'clusters',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': ['get', 'point_count_abbreviated'],
                'text-font': ['DIN Offc Pro Bold'],
                'text-size': 12,
                'text-allow-overlap': true,
            },
        });

        mapbox.addLayer({
            id: 'markers',
            type: 'symbol',
            source: 'clusters',
            filter: ['!', ['has', 'point_count']],
            layout: {
                'icon-image': [
                    'case',
                    ['get', 'selected'],
                    'bf-marker-selected',
                    'bf-marker',
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        }, 'circles');
    };

    /**
     * Updates map clusters
     */
    const updateClusters = () => {
        if (!clusters || typeof mapbox === 'undefined') {
            return;
        }

        const isMobile = getScreenSize(MOBILE_MAX_WIDTH);
        const padding = isMobile ? 50 : { left: 620 };
        const bbox = new mapboxgl.LngLatBounds(); // eslint-disable-line no-undef
        const clustersSource = mapbox.getSource('clusters');

        if (clustersSource) {
            clustersSource.setData(clusters);
            mapbox.triggerRepaint();
        } else {
            const countryCode = getCountryCode();
            const countryConfiguration = coordinates && coordinates[countryCode];
            buildClusters(countryConfiguration.clusterRadius);
        }

        clusters.features.forEach((feature) => {
            bbox.extend(feature.geometry.coordinates);
        });

        mapbox.fitBounds(bbox, { padding });
    };

    /**
     * Handles the success scenario of the geolocation request that is made for the club finder page
     * @param {Object} position - The position object returned by the browser
     */
    const callback = (position) => {
        const $grid = $('.js-club-finder-grid');
        const $backToTop = $('.js-back-to-top');
        const $backToTopLink = $backToTop.find('a');
        const $loader = $('.js-loader');
        const moreUrl = $grid.attr('data-more-url');
        const lat = position.coords.latitude;
        const long = position.coords.longitude;

        buildLocation(lat, long, true);

        $grid.attr('data-latitude', lat);
        $grid.attr('data-longitude', long);
        $backToTopLink.removeClass('active');
        $grid.find('.js-store-tile, .js-club-finder-grid-sentinel, .hr').each((i, element) => {
            $(element).remove();
        });
        $loader.loader().start();

        const url = enrichUrl(moreUrl, null, false, false);

        $.ajax({
            url,
            type: 'GET',
            dataType: 'json',
            success: (data) => {
                $loader.loader().stop();
                $loader.remove();

                $backToTop.before(data.storeTilesHtml);
                $grid.attr('data-page-start', data.pageStart);
                $grid.attr('data-page-size', data.pageSize);
                $grid.attr('data-page-complete', data.isComplete);

                updateUrl({
                    lat,
                    long,
                    s: null,
                    sz: null,
                });

                const $tiles = $grid.find('.js-store-tile');
                $tiles.each((i, tile) => {
                    swiperIntersectionObserver.observe(tile);
                });

                if (data.isComplete) {
                    $backToTopLink.toggleClass('active', $tiles.length > 5);
                } else {
                    buildSentinel();
                }
            },
        });
    };

    /**
     * Updates grid scroll position
     */
    const updateScrollPosition = () => {
        const $list = $('.js-club-finder-list');

        const prevState = Object.assign({}, window.history.state, {
            previousPosition: $list.scrollTop(),
        });
        window.history.replaceState(prevState, null);
    };

    /**
     * Scrolls to the previous position in the grid
     */
    const scrollToPreviousPosition = () => {
        const {state} = window.history;

        if (state && state.previousPosition !== undefined) {
            const $list = $('.js-club-finder-list');

            setTimeout(() => {
                $list.animate({
                    scrollTop: state.previousPosition,
                }, 'slow');

                const newState = { ...state};
                delete newState.previousPosition;

                window.history.replaceState(newState, null);
            }, 500);
        }
    };

    /**
     * Gets store search suggestions
     * @param {HTMLElement} $wrapper - Wrapper HTML element for the search suggestions result
     * @param {boolean} isSubmitButtonActive - True if the submit button should be enabled, False otherwise
     */
    const getSearchSuggestions = ($wrapper, isSubmitButtonActive) => {
        const $form = $('.js-club-finder-search-form');
        const $mapbox = $('.js-club-finder-mapbox');
        const action = $form.attr('data-suggestions-url');
        const url = enrichUrl(action, null, false, true);

        $.ajax({
            url,
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                $wrapper.empty();
                $wrapper.html(data.storeSuggestionsHtml);
                toggleSearchSubmitButton(data.count > 0 && isSubmitButtonActive);

                $mapbox.addClass('club-finder-mapbox—-disabled');
            },
        });
    };

    /**
     * Fetches stores when the search form is triggered
     */
    const search = () => {
        const $form = $('.js-club-finder-search-form');
        const $selectedStoreWrapper = $('.js-selected-store-wrapper');
        const $filtersButton = $('.js-club-finder-filters');
        const $filtersSubmitButton = $('.js-club-finder-filters-submit');
        const $filtersSubmitButtonText = $filtersSubmitButton.find('span');
        const $countText = $('.js-list-header-count-text');
        const $grid = $('.js-club-finder-grid');
        const $storeWrapper = $('.js-club-finder-stores');
        const $searchInput = $('.js-club-finder-search-input');
        const $backToTop = $('.js-back-to-top');
        const $backToTopLink = $backToTop.find('a');
        const $loader = $('<li />');
        const q = $searchInput.val() || null;
        const action = $form.attr('action');
        const selectedFilters = getSelectedFilters();
        const filters = selectedFilters.length > 0 ? selectedFilters : null;
        const url = enrichUrl(action, null, false, false);

        closePopups();
        destroySelectedClubSwiper();
        $searchInput.blur();
        $selectedStoreWrapper.html('');
        $selectedStoreWrapper.removeClass('active midway up');
        $selectedStoreWrapper.removeAttr('style');
        $backToTopLink.removeClass('active');
        $grid.find('.js-store-tile, .js-club-finder-grid-sentinel, .hr, .js-loader').each((i, element) => {
            $(element).remove();
        });
        $loader.addClass('loadcontainer js-loader');
        $backToTop.before($loader);
        $loader.loader().start();

        $.ajax({
            url,
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                $loader.loader().stop();
                $loader.remove();

                $storeWrapper.toggleClass('club-finder-stores--active', data.count > 0);
                $backToTop.before(data.searchHtml);
                $countText.html(data.countText);
                $grid.attr('data-page-start', data.pageStart);
                $grid.attr('data-page-size', data.pageSize);
                $grid.attr('data-page-complete', data.isComplete);
                $filtersSubmitButton.prop('disabled', data.count < 1);
                $filtersSubmitButtonText.html(data.filterButtonText);
                $filtersButton.attr('data-selected-filters-count', data.selectedFiltersCount);
                $filtersButton.toggleClass('filters-selected', !!data.selectedFiltersCount);

                clusters = data.clusters;

                updateClusters();
                updateUrl({
                    q,
                    filters,
                    s: null,
                    sz: null,
                });

                const $tiles = $grid.find('.js-store-tile');
                $tiles.each((i, tile) => {
                    swiperIntersectionObserver.observe(tile);
                });

                if (data.isComplete) {
                    $backToTopLink.toggleClass('active', $tiles.length > 5);
                } else {
                    buildSentinel();
                }
            },
        });
    };

    /**
     * Fetches store count when the filter is clicked
     */
    const filter = () => {
        const $form = $('.js-club-finder-search-form');
        const $filtersSubmitButton = $('.js-club-finder-filters-submit');
        const $filtersSubmitButtonText = $filtersSubmitButton.find('span');
        const action = $form.attr('action');
        const url = enrichUrl(action, null, false, false);

        $.ajax({
            url,
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                $filtersSubmitButton.prop('disabled', data.count < 1);
                $filtersSubmitButtonText.html(data.filterButtonText);
            },
        });
    };

    /**
     * Closes search suggestion and filter popups
     */
    const closePopups = () => {
        const $suggestions = $('.js-club-finder-suggestions');
        const $filters = $('.js-club-finder-filters-wrapper');
        const $mapbox = $('.js-club-finder-mapbox');

        $suggestions.empty();
        $filters.hide();
        $mapbox.removeClass('club-finder-mapbox—-disabled');
        searchSuggestionsModal('close');
        toggleSearchSubmitButton(false);
    };

    /**
     * Updates filter checkboxes
     */
    const updateFilterCheckboxes = () => {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        const appliedFilters = searchParams.get('filters');
        const filters = appliedFilters ? appliedFilters.split(',') : [];
        const $checkboxes = $('.js-club-finder-filter');

        $checkboxes.each((i, checkbox) => {
            const $checkbox = $(checkbox);
            const name = $checkbox.attr('name');

            $checkbox.prop('checked', filters.indexOf(name) > -1);
        });
    };

    /**
     * Toggles mobile 'modal layout', based on the provided state.
     * @param {string} state - The state of the  view, either 'open' or 'close'.
     */
    const searchSuggestionsModal = (state) => {
        const $searchWrapper = $('.club-finder-search-wrapper');

        if (state === 'open') {
            $searchWrapper.addClass('search-suggestions-modal');

        } else if (state === 'close') {
            $searchWrapper.removeClass('search-suggestions-modal');
        }
    };

    /**
     * Initializes browser geolocation prompt
     */
    const initLocation = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const q = searchParams.get('q');
        const lat = searchParams.get('lat');
        const long = searchParams.get('long');

        if (lat && long) {
            const isZoomIn = !q;
            buildLocation(lat, long, isZoomIn);
            return;
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(callback);
        }
    };

    /**
     * Destroys selected club swiper
     */
    const destroySelectedClubSwiper = () => {
        if (typeof selectedClubSwiper === 'undefined') {
            return;
        }

        selectedClubSwiper.destroy({
            cleanStyles: true,
        });
        selectedClubSwiper = undefined;
    };

    /**
     * Updates club markers on the map
     * @param {?string} id - Store id or null
     */
    const updateClubMarkers = (id) => {
        if (!clusters || typeof mapbox === 'undefined') {
            return;
        }

        const clustersData = clusters;

        clustersData.features = clusters.features.map((feature) => {
            feature.properties.selected = feature.properties.ID === id; // eslint-disable-line no-param-reassign
            return feature;
        });

        mapbox.getSource('clusters').setData(clustersData);
    };

    /**
     * Initializes map box for the store finder page
     */
    const initMapBox = () => {
        const $mapbox = $('.js-club-finder-mapbox');
        const container = $mapbox.attr('id');
        const mapUrl = $mapbox.attr('data-map-url');
        const storeUrl = $mapbox.attr('data-store-url');
        const url = enrichUrl(mapUrl, null, false, false);
        const $searchInput = $('.js-club-finder-search-input');

        $.ajax({
            url,
            type: 'GET',
            dataType: 'json',
            success: (data) => {
                const countryCode = getCountryCode();
                const resolution = getScreenResolution();
                const countryConfiguration = coordinates && coordinates[countryCode];
                const configuration = countryConfiguration && countryConfiguration[resolution];
                const isMobile = getScreenSize(MOBILE_MAX_WIDTH);
                const padding = isMobile ? 50 : { left: 620 };
                const bbox = new mapboxgl.LngLatBounds(); // eslint-disable-line no-undef
                const bounds = new mapboxgl.LngLatBounds( // eslint-disable-line no-undef
                    new mapboxgl.LngLat(configuration[0], configuration[1]), // eslint-disable-line no-undef
                    new mapboxgl.LngLat(configuration[2], configuration[3]), // eslint-disable-line no-undef
                );
                const customIcons = [
                    {
                        src: data.bfMarker,
                        name: 'bf-marker',
                        width: 30,
                        height: 43,
                    },
                    {
                        src: data.bfMarkerSelected,
                        name: 'bf-marker-selected',
                        width: 34,
                        height: 48,
                    },
                ];

                clusters = data.clusters;

                mapboxgl.accessToken = data.apiKey; // eslint-disable-line no-undef

                mapbox = new mapboxgl.Map({ // eslint-disable-line no-undef
                    container,
                    style: 'mapbox://styles/mapbox/streets-v11',
                    bounds,
                    pitchWithRotate: false,
                    dragRotate: false,
                    id: 'symbols',
                    maxZoom: 16,
                    touchZoomRotate: true,
                });

                mapbox.addControl(new mapboxgl.NavigationControl()); // eslint-disable-line no-undef

                if (clusters && clusters.features.length > 0) {
                    clusters.features.forEach((feature) => {
                        bbox.extend(feature.geometry.coordinates);
                    });
                    mapbox.fitBounds(bbox, { padding });
                }

                mapbox.on('load', () => {
                    adjustMapView(mapbox);

                    customIcons.forEach((customIcon) => {
                        const icon = new Image(customIcon.width, customIcon.height);
                        icon.onload = () => {
                            mapbox.addImage(customIcon.name, icon);

                            if (customIcon.name === 'bf-marker') {
                                buildClusters(countryConfiguration.clusterRadius);
                                initLocation();
                                location(callback);
                            }
                        };
                        icon.src = customIcon.src;
                    });

                    mapbox.on('click', (e) => {
                        const markers = mapbox.queryRenderedFeatures(e.point, {
                            layers: ['markers'],
                        });

                        if (markers.length > 0) {
                            return;
                        }

                        const $selectedStoreWrapper = $('.js-selected-store-wrapper');

                        detailToggle('close');

                        setTimeout(() => {
                            updateClubMarkers(null);
                            destroySelectedClubSwiper();
                            $selectedStoreWrapper.html('');
                        }, 500);
                    });

                    mapbox.on('click', 'circles', (e) => {
                        const circles = mapbox.queryRenderedFeatures(e.point, {
                            layers: ['circles'],
                        });
                        const id = circles[0].properties.cluster_id;

                        mapbox.getSource('clusters').getClusterExpansionZoom(id, (clusterExpansionError) => {
                            if (clusterExpansionError) {
                                return;
                            }

                            const currentZoom = mapbox.getZoom();
                            const zoom = currentZoom < DEFAULT_ZOOM_LEVEL ? DEFAULT_ZOOM_LEVEL : currentZoom + 2;

                            mapbox.flyTo({
                                center: circles[0].geometry.coordinates,
                                offset: [100, 0],
                                zoom,
                                speed: 0.6,
                            });
                        });
                    });

                    mapbox.on('mouseenter', 'circles', () => {
                        mapbox.getCanvas().style.cursor = 'pointer';
                    });

                    mapbox.on('mouseleave', 'circles', () => {
                        mapbox.getCanvas().style.cursor = '';
                    });

                    mapbox.on('click', 'markers', (e) => {
                        const circles = mapbox.queryRenderedFeatures(e.point, {
                            layers: ['circles'],
                        });

                        if (circles.length > 0) {
                            return;
                        }

                        const store = e.features[0];
                        const center = store.geometry.coordinates.slice();
                        const id = store.properties.ID;
                        const action = enrichUrl(storeUrl, id, false, false);

                        $.ajax({
                            url: action,
                            type: 'GET',
                            dataType: 'json',
                            success: (storeData) => {
                                const $selectedStoreWrapper = $('.js-selected-store-wrapper');
                                $selectedStoreWrapper.html(`<span class="drag-tag js-details-drag-tag"></span> ${storeData.storeTileHtml}`);

                                const $selectedTile = $selectedStoreWrapper.find('.js-store-tile');
                                swiperIntersectionObserver.observe($selectedTile[0]);

                                collapseDrawer();
                                detailToggle('open');
                            },
                        });

                        updateClubMarkers(id);

                        mapbox.flyTo({
                            center,
                            offset: [100, 0],
                            speed: 0.3,
                        });
                    });

                    mapbox.on('mouseenter', 'markers', () => {
                        mapbox.getCanvas().style.cursor = 'pointer';
                    });

                    mapbox.on('mouseleave', 'markers', () => {
                        mapbox.getCanvas().style.cursor = '';
                    });

                    // Enhance accessibility of Mapbox controls
                    setTimeout(() => {
                        const $compassButton = $('.mapboxgl-ctrl-compass');
                        const $zoomOutButton = $('.mapboxgl-ctrl-zoom-out');


                        if ($compassButton.length) {
                            $compassButton.attr('tabindex', '-1');
                        }

                        if ($zoomOutButton.length && $searchInput.length) {
                            $zoomOutButton.on('keydown', (e) => {
                                if (e.key === KEYBOARD_KEYS.TAB && !e.shiftKey) {
                                    e.preventDefault();
                                    $searchInput.focus();
                                }
                            });
                        }
                    }, 200); // Delay to ensure Mapbox controls are rendered

                    const $locationButton = $('.js-location');

                    if ($locationButton.length && $searchInput.length) {
                        $locationButton.on('keydown', (e) => {
                            if (e.key === KEYBOARD_KEYS.TAB && e.shiftKey) {
                                e.preventDefault();
                                $searchInput.focus();
                            }
                        });
                    }
                });
            },
        });
    };

    /**
     * Initializes Intersection Observer API for the current store grid
     */
    const initStoreGrid = () => {
        const $grid = $('.js-club-finder-grid');
        const $tiles = $grid.find('.js-store-tile');
        const $backToTopLink = $('.js-back-to-top a');
        const isComplete = $grid.attr('data-page-complete') === 'true';
        const firstId = $tiles.eq(0).attr('data-pid');
        const isMobile = getScreenSize(MOBILE_MAX_WIDTH);

        if (!isComplete) {
            buildSentinel();
        } else {
            $backToTopLink.toggleClass('active', $tiles.length > 5);
        }

        swiperIntersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const tile = entry.target;
                const $tile = $(tile);

                if (entry.isIntersecting && (entry.intersectionRatio > 0 || isFirstMobileTile($tile, firstId, isMobile))) {
                    if ($tile.hasClass('store-tile--selected')) {
                        selectedClubSwiper = initSwiper($tile, true);
                    } else {
                        initSwiper($tile, false);
                    }

                    swiperIntersectionObserver.unobserve(tile);
                }
            });
        });

        $tiles.each((i, tile) => {
            swiperIntersectionObserver.observe(tile);
        });

        scrollToPreviousPosition();
    };

    /**
     * Initializes event listeners for store finder page
     */
    const initEventListeners = () => {
        const $body = $('body');
        const $form = $('.js-club-finder-search-form');
        const $searchInput = $('.js-club-finder-search-input');
        const $searchWrapper = $('.club-finder-search-wrapper');
        const $filtersButton = $('.js-club-finder-filters');
        const $filtersCloseButton = $('.js-club-finder-filters-close');
        const $filtersSubmitButton = $('.js-club-finder-filters-submit');
        const $filtersClearButton = $('.js-club-finder-filters-clear');
        const $searchClearButton = $('.js-club-finder-search-clear');

        $body.on('click', (e) => {
            const $target = $(e.target);
            const $insideSearchWrapper = $target.closest('.club-finder-search-wrapper');
            const isSearchWrapper = $insideSearchWrapper.length > 0;

            if (isSearchWrapper) {
                return;
            }

            closePopups();
            updateFilterCheckboxes();
            filter();
            searchSuggestionsModal('close');
        });

        $body.on('click', '.js-store-tile-link', (e) => {
            e.preventDefault();

            const $target = $(e.currentTarget);
            const url = $target.attr('href');

            updateScrollPosition();
            window.location = url;
        });

        $body.on('click', '.js-store-tile-lead-gen-club, .js-store-tile-presale-club', (e) => {
            e.preventDefault();

            const $target = $(e.target);
            let $tile = $target.closest('.js-store-tile');

            if ($tile.length < 1) {
                $tile = $target.closest('.js-store-tile-suggestions');
            }

            const storeId = $tile.attr('data-pid');
            const url = $tile.hasClass('js-store-tile-lead-gen-club') ? $tile.attr('data-lead-gen-url') : $tile.attr('data-pre-sale-url');

            updateScrollPosition();
            window.location = `${url}?sid=${storeId}`;
        });

        $body.on('click', '.js-join', (e) => {
            e.preventDefault();

            const $target = $(e.target);
            const $tile = $target.closest('.js-store-tile');
            const storeId = $tile.attr('data-pid');
            const membershipId = $target.attr('data-membership-id');
            const duration = $target.attr('data-duration');

            updateScrollPosition();
            addProduct(storeId, membershipId, null, duration);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            
            const EVENT_PARAM_PAGE_SOURCE = 'page_source';
            const PAGE_SOURCE_CLUB_FINDER = 'club_finder';
            const event = new GtmParametersBuilder()
                .withEvent('go_to_checkout')
                .withParameter('button_type', 'club')
                .withParameter('checkout_step', '2')
                .withParameter(EVENT_PARAM_PAGE_SOURCE, PAGE_SOURCE_CLUB_FINDER)
                .build();

            window.dataLayer.push(event);
        });

        $body.on('click', '.js-back-to-top a', (e) => {
            e.preventDefault();

            const $grid = $('.js-club-finder-grid');
            const $firstItem = $grid.find('li:not(.hr)').first();

            $firstItem.get(0).scrollIntoView({ behavior: 'smooth', block: 'start' });
            $firstItem.focus();
        });

        $body.on('click', '.js-location-error-close', () => {
            $('.js-location-error')
                .addClass('display-none')
                .attr('aria-hidden', 'true');
        });

        $body.on('click', '.js-search-suggestions-modal-close', () => {
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams(url.search);
            const q = searchParams.get('q') || '';

            $searchInput.val(q);
            $searchInput.blur();

            if (q.length < 1) {
                $searchWrapper.removeClass('club-finder-search-clearbutton--active');
            }

            closePopups();
        });

        $body.on('click', '.js-club-finder-city', (e) => {
            e.preventDefault();

            const $target = $(e.currentTarget);
            const name = $target.attr('data-city-name');
            $searchInput.val(name);

            search();
        });

        $body.on('click', '.js-club-finder-filter', filter);

        $form.on('submit', (e) => {
            e.preventDefault();
            search();
        });

        $searchInput.on('keyup', (e) => {
            const code = e.key;
            const q = $searchInput.val();
            const $suggestions = $('.js-club-finder-suggestions');


            $searchWrapper.toggleClass('club-finder-search-clearbutton--active', q.length > 0);

            if (e.key === KEYBOARD_KEYS.ESC) {
                $searchInput.blur();
            }

            if (e.key === KEYBOARD_KEYS.BACKSPACE && q.length < 1) {
                search();
                return;
            }

            if (q.length < 3) {
                searchSuggestionsModal('open');
                return;
            }

            if (code !== 'Enter') {
                getSearchSuggestions($suggestions, true);
                searchSuggestionsModal('open');
                return;
            }
        });

        $searchInput.on('focus', () => {
            const q = $searchInput.val();


            if (q.length > 2) {
                const $suggestions = $('.js-club-finder-suggestions');

                getSearchSuggestions($suggestions, false);
            }

            searchSuggestionsModal('open');
        });

        $searchClearButton.on('click', () => {
            $searchInput.val('');
            $searchWrapper.removeClass('club-finder-search-clearbutton--active');

            closePopups();
            toggleSearchSubmitButton(true);

            // Improve a11y: return focus to the input
            if (isKeyboardNavigation) {
                $searchInput.focus();
            }
        });

        $filtersButton.on('click', () => {
            const $filters = $('.js-club-finder-filters-wrapper');
            const $mapbox = $('.js-club-finder-mapbox');

            $filters.css('display', 'flex');
            $mapbox.addClass('club-finder-mapbox—-disabled');

            // Trap focus
            trapModalFocus($filters);
        });

        $filtersCloseButton.on('click', () => {
            const $filters = $('.js-club-finder-filters-wrapper');

            updateFilterCheckboxes();
            filter();
            closePopups();

            // Unbind trap
            $filters.off('keydown.trapFocus');
            $filters.attr('aria-hidden', 'true');
            $filters.css('display', 'none');

            // Return focus to trigger
            $filtersButton.trigger('focus');
        });

        $filtersSubmitButton.on('click', search);

        $filtersClearButton.on('click', () => {
            const $selectedFilters = $('.js-club-finder-filter:checked');

            $selectedFilters.prop('checked', false);

            filter();
        });

        $(document).on('keydown', (e) => {
            const $filters = $('.js-club-finder-filters-wrapper');
            if (e.key === KEYBOARD_KEYS.ESC && $filters.is(':visible')) {
                $filtersCloseButton.trigger('click');
            }
        });
    };

    /**
     * Dragable list on Mobile
     */
    const listDrag = () => {
        const isMobile = getScreenSize(MOBILE_MAX_WIDTH);
        const dragThreshold = 5; // Threshold in pixels for automatic expansion/shrinkage
        const drawerStartHeight = 52; // the drawers start height on mobile
        const drawerMaxHeightMin = 76; // the drawers max height is 100% minus this amount

        const $container = $('.club-finder'); // total wrapper where everything including the map lives in
        const $bottomDrawer = $('.club-finder-stores'); // the container we grow, shrink and drag
        const $touchArea = $('.club-finder-list-header'); // drag handler

        let isDragging = false;
        let startY;
        let startHeight;
        let lastY;
        let dragDirection; // Global variable to track drag direction

        // Event listener for mouse down or touch start on the draggable area
        function startListDragTouch(e) {
            if (isMobile) {
                e.preventDefault();
                isDragging = true;
                startY = e.clientY ?? e.touches?.[0]?.clientY;
                startHeight = parseInt($bottomDrawer.css('height'));
                $('body').addClass('dragging');

                $(document).on('mousemove', drag); // jQuery
                document.addEventListener('touchmove', drag, { passive: false }); // native

                $(document).on('mouseup touchend', endDrag);
            }
        }

        function startListDragMouse(e) {
            if (isMobile) {
                e.preventDefault();
                isDragging = true;
                startY = e.clientY;
                startHeight = parseInt($bottomDrawer.css('height'));
                $('body').addClass('dragging');

                $(document).on('mousemove', drag);
                $(document).on('mouseup touchend', endDrag);
            }
        }

        $touchArea[0].addEventListener('touchstart', startListDragTouch, { passive: false }); // native
        $touchArea.on('mousedown', startListDragMouse); // jQuer

        if (!isMobile) {
            // cleanup mobile swipe remnants on desktop / tablet after sudden resize
            cleanDrag();
        }

        function cleanDrag() {
            $touchArea[0].removeEventListener('touchstart', startListDragTouch, { passive: false });
            $touchArea.off('mousedown', startListDragMouse);
            $(document).off('mousemove', drag);
            $('body').removeClass('dragging');
            $bottomDrawer.removeAttr('style');
        }

        function drag(e) {
            if (!isDragging) return; // Exit if not dragging
            e.preventDefault(); // Prevent default behavior (text selection, scrolling)

            // Calculate the distance dragged vertically relative to the container
            const clientY = e.clientY || (e.touches && e.touches[0]?.clientY);
            const deltaY = startY - clientY;
            const containerHeight = $container.height();
            const newHeight = startHeight + deltaY;

            // Determine drag direction
            if (clientY < lastY) {
                dragDirection = 'up';
            } else if (clientY > lastY) {
                dragDirection = 'down';
            }

            lastY = clientY; // Update last Y position

            // Ensure the new height stays within bounds
            if (newHeight >= drawerStartHeight && newHeight <= (containerHeight - drawerMaxHeightMin)) {
                $bottomDrawer.css('height', `${newHeight}px`); // Set new height
            }
        }

        function endDrag(e) {
            // clean up classes and binding:
            isDragging = false;
            $('body').removeClass('dragging');
            // touchmove split
            $(document).off('mousemove', drag); // jQuery
            document.removeEventListener('touchmove', drag, { passive: false }); // native
            $(document).off('mouseup touchend', endDrag);

            // Automatically expand/shrink if the user drags at least the threshold distance
            const distance = Math.abs(startY - (e.clientY || e.originalEvent.changedTouches[0].clientY));
            if (distance >= dragThreshold) {
                if (dragDirection === 'up' && parseInt($bottomDrawer.css('height')) > drawerStartHeight) {
                    $bottomDrawer.css('height', `calc(100% - ${drawerMaxHeightMin}px)`);
                } else if (dragDirection === 'down' && parseInt($bottomDrawer.css('height')) < ($container.height() - drawerMaxHeightMin)) {
                    $bottomDrawer.css('height', `${drawerStartHeight}px`);
                }
            }
        }
    };

    /**
     * Collapses drawer on Mobile
     */
    const collapseDrawer = () => {
        const isMobile = getScreenSize(MOBILE_MAX_WIDTH);
        const drawerStartHeight = 52; // the drawers start height on mobile
        const $bottomDrawer = $('.club-finder-stores');

        if (isMobile) {
            $bottomDrawer.css('height', `${drawerStartHeight}px`); // Set new height
        }
    };

    /**
     * Dragable detail tile on Mobile
     */
    const detailDrag = () => {
        const isMobile = getScreenSize(MOBILE_MAX_WIDTH);
        const dragThreshold = 5; // Threshold in pixels for automatic expansion/shrinkage
        const storeDetailDownState = 65; // minimal height on mobile
        const storeDetailMidState = 250; // half way position
        let storeDetailUpState; // the max height (default will be overwritten with real size on opening)

        const $storeDetailTile = $('.js-selected-store-wrapper'); // the container we grow, shrink and drag
        const dragHandle = 'js-details-drag-tag'; // drag handler

        let isDragging = false;
        let startY;
        let startHeight;
        let lastY;
        let dragDirection; // Global variable to track drag direction

        const endDragDetail = (e) => {
            // clean up classes and binding:
            isDragging = false;
            $('body').removeClass('dragging');
            // touchmove split
            $(document).off('mousemove', dragDetail); // jQuery
            document.removeEventListener('touchmove', dragDetail, { passive: false }); // native
            $(document).off('mouseup touchend', endDragDetail);

            // Automatically expand/shrink if the user drags at least the threshold distance
            const distance = Math.abs(startY - (e.clientY || e.originalEvent.changedTouches[0].clientY));
            if (distance >= dragThreshold) {
                const currentSize = parseInt($storeDetailTile.css('height'));
                if (dragDirection === 'up') {
                    if (currentSize >= storeDetailDownState && currentSize <= storeDetailMidState) {
                        $storeDetailTile.css('height', `${storeDetailMidState}px`);
                        $storeDetailTile.addClass('midway');
                        $storeDetailTile.removeClass('up');
                    } else if (currentSize <= storeDetailUpState && currentSize > storeDetailMidState) {
                        $storeDetailTile.css('height', `${storeDetailUpState}px`);
                        $storeDetailTile.addClass('up');
                        $storeDetailTile.removeClass('midway');
                    }
                } else if (dragDirection === 'down') {
                    if (currentSize >= storeDetailDownState && currentSize <= storeDetailMidState) {
                        $storeDetailTile.css('height', `${storeDetailDownState}px`);
                        $storeDetailTile.removeClass('midway up');
                    } else if (currentSize <= storeDetailUpState && currentSize > storeDetailMidState) {
                        $storeDetailTile.css('height', `${storeDetailMidState}px`);
                        $storeDetailTile.addClass('midway');
                        $storeDetailTile.removeClass('up');
                    }
                }
            }
        };

        // Event listener for mouse down or touch start on the draggable area (split)
        function startDetailDragTouch(e) {
            if (isMobile && e.target.classList.contains(dragHandle)) {
                storeDetailUpState = realMobileCLubDetailHeight || 450;
                e.preventDefault();
                isDragging = true;
                startY = e.clientY ?? e.touches?.[0]?.clientY;
                startHeight = parseInt($storeDetailTile.css('height'));
                $('body').addClass('dragging');

                $(document).on('mousemove', dragDetail);
                document.addEventListener('touchmove', dragDetail, { passive: false });

                $(document).on('mouseup touchend', endDragDetail);
            }
        }

        function startDetailDragMouse(e) {
            if (isMobile && $(e.target).hasClass(dragHandle)) {
                storeDetailUpState = realMobileCLubDetailHeight || 450;
                e.preventDefault();
                isDragging = true;
                startY = e.clientY;
                startHeight = parseInt($storeDetailTile.css('height'));
                $('body').addClass('dragging');

                $(document).on('mousemove', dragDetail);
                $(document).on('mouseup touchend', endDragDetail);
            }
        }

        document.addEventListener('touchstart', startDetailDragTouch, { passive: false });
        $(document).on('mousedown', startDetailDragMouse);


        if (!isMobile) {
            // cleanup mobile swipe remnants on desktop / tablet after sudden resize
            cleanDrag();
        }

        function cleanDrag() {
            document.removeEventListener('touchstart', startDetailDragTouch, { passive: false });
            $(document).off('mousedown', startDetailDragMouse);
            $(document).off('mousemove', dragDetail);
            document.removeEventListener('touchmove', dragDetail, { passive: false });
            $(document).off('mouseup touchend', endDragDetail);
            $('body').removeClass('dragging');
            $storeDetailTile.removeClass('midway up');
            $storeDetailTile.removeAttr('style');
        }

        function dragDetail(e) {
            if (!isDragging) return; // Exit if not dragging
            e.preventDefault(); // Prevent default behavior (text selection, scrolling)

            // Calculate the distance dragged vertically relative to the container
            const clientY = e.clientY || (e.touches && e.touches[0]?.clientY);
            const deltaY = startY - clientY;
            const newHeight = startHeight + deltaY;

            // Determine drag direction
            if (clientY < lastY) {
                dragDirection = 'up';
            } else if (clientY > lastY) {
                dragDirection = 'down';
            }

            lastY = clientY; // Update last Y position

            // Ensure the new height stays within bounds
            if (newHeight >= storeDetailDownState && newHeight <= storeDetailUpState) {
                $storeDetailTile.css('height', `${newHeight}px`); // Set new height
            }
        }
    };

    /**
     * Toggles the detail view of a store, based on the provided state.
     * Sets the global variable `realMobileCLubDetailHeight` on mobile to remember the real tile height.
     * @param {string} state - The state of the detail view, either 'open' or 'close'.
     */
    const detailToggle = (state) => {
        const $selectedStoreWrapper = $('.js-selected-store-wrapper');
        // available space to maximize to
        const clubFinderCanvasSpace = $('.club-finder').height() - 76;
        const isMobile = getScreenSize(MOBILE_MAX_WIDTH);

        if (state === 'open') {
            // measurements on mobile:
            if (isMobile) {
                if ($selectedStoreWrapper.hasClass('up')) {
                    $selectedStoreWrapper.removeAttr('style');
                    // animate to midway before measuring the real size of the next content
                    setTimeout(() => {
                        $selectedStoreWrapper.removeClass('active up');
                        // measure:
                        $selectedStoreWrapper.addClass('measure');
                        realMobileCLubDetailHeight = $selectedStoreWrapper.height();
                        $selectedStoreWrapper.removeClass('measure');
                        if (realMobileCLubDetailHeight > clubFinderCanvasSpace) {
                            realMobileCLubDetailHeight = clubFinderCanvasSpace;
                        }
                        $selectedStoreWrapper.addClass('active midway');
                    }, 500);
                } else {
                    $selectedStoreWrapper.removeAttr('style');
                    $selectedStoreWrapper.removeClass('active');
                    // measure:
                    $selectedStoreWrapper.addClass('measure');
                    realMobileCLubDetailHeight = $selectedStoreWrapper.height();
                    if (realMobileCLubDetailHeight > clubFinderCanvasSpace) {
                        realMobileCLubDetailHeight = clubFinderCanvasSpace;
                    }
                    $selectedStoreWrapper.removeClass('measure');
                    // no need for animation in an open window
                    if ($selectedStoreWrapper.hasClass('midway')) {
                        $selectedStoreWrapper.addClass('active');
                    } else {
                        //  wait for animation (case: minimized or first time open)
                        setTimeout(() => {
                            $selectedStoreWrapper.addClass('active midway');
                        }, 10);
                    }
                }
            } else {
                $selectedStoreWrapper.addClass('active');
            }
        } else if (state === 'close') {
            $selectedStoreWrapper.removeClass('active midway up');
            $selectedStoreWrapper.removeAttr('style');
        }
    };

    return {
        init() {
            initMapBox();
            initEventListeners();
            initStoreGrid();
            listDrag();
            detailDrag();
            scrollLock('on');
        },
        resize() {
            listDrag();
            detailDrag();
        },
    };
})();

export default (() => {
    $(document).ready(Finder.init);
    $(window).on('resize', debounce(Finder.resize, 300));
})();
